import { DocumentsUpload } from '@/features/DocumentsUpload/DocumentsUpload';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const documentsUploadSearchSchema = z.object({
    projectId: z.number().optional(),
    aircraftId: z.number().optional(),
    isProjectView: z.boolean().optional(),
    isAircraftView: z.boolean().optional(),
    isAssetView: z.boolean().optional(),
    isAssetBinderView: z.boolean().optional(),
    assetId: z.number().optional(),
    collectionId: z.number().optional(),
    showPipeline: z.boolean().optional(),
    folder: z.string().optional(),
    sub: z.string().optional(),
    custom: z.string().optional(),
    doc: z.number().optional(),
});

export const Route = createFileRoute('/documents/upload/')({
    component: DocumentsUpload,
    validateSearch: documentsUploadSearchSchema,
});
